export default {"src":"/_next/static/media/contact_mobile.1c1e3e37.svg","height":533,"width":430,"blurWidth":0,"blurHeight":0};